// Plugin to migrate user preferences from cookies to localStorage
// and clean up old cookies to reduce request header size

export default defineNuxtPlugin(() => {
  if (typeof document === 'undefined') return

  // Get all cookies
  const cookies = document.cookie.split(';')

  cookies.forEach(cookie => {
    const [nameWithSpaces, value] = cookie.split('=')
    const name = nameWithSpaces?.trim()
    
    if (!name || !name.startsWith('user-pref-')) return

    // Delete the cookie by setting it to expire in the past
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      console.log(`[Cleanup] Deleted cookie: ${name}`)
    } catch (error) {
      console.error(`[Migration] Error migrating cookie ${name}:`, error)
    }
  })
})

